import { render, staticRenderFns } from "./EditDataSim.vue?vue&type=template&id=34bdb756"
import script from "./EditDataSim.vue?vue&type=script&lang=js"
export * from "./EditDataSim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports